import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DocumentationPageComponent} from './documentation/documentation-page/documentation-page.component';
import {DocumentationFieldsComponent} from './documentation/documentation-page/documentation-fields/documentation-fields.component';
import {DocumentationAccordionComponent} from './documentation/documentation-page/documentation-accordion/documentation-accordion.component';
import {DocumentationOrgChartComponent} from './documentation/documentation-page/documentation-org-chart/documentation-org-chart.component';
import {DocumentationTableComponent} from './documentation/documentation-page/documentation-table/documentation-table.component';

const routes: Routes = [
  {
    path: 'core',
    children: [
      {
        path: '',
        redirectTo: 'documentation',
        pathMatch: 'full'
      },
      {
        path: 'documentation',
        component: DocumentationPageComponent,
        children: [
          {
            path: '',
            redirectTo: 'fields',
            pathMatch: 'full'
          },
          {
            path: 'accordion',
            component: DocumentationAccordionComponent
          },
          {
            path: 'fields',
            component: DocumentationFieldsComponent
          },
          {
            path: 'org-chart',
            component: DocumentationOrgChartComponent
          },
          {
            path: 'table',
            component: DocumentationTableComponent
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FrontBaseAngularCoreRoutingModule {
}
